import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  Box,
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  CircularProgress,
  IconButton,
  Typography,
} from "@mui/material";
import { ArrowRight, ArrowDropDown } from "@mui/icons-material";
import SideBar from "../SideBar/SideBar";
import styles from "./transaction.module.css";
import TransactionFilter from "../TransactionFilter/TransactionFilter";
import Header from "../Header/Header";
import { useAllProduct } from "../../api-context/commonApiContext";
import Footer from "../Footer/Footer";
import axios from "axios";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import config from "../../service/config";
import FullScreenLoader from "../../reusable/loader/FullScreenLoader";

const Transaction = () => {
  const {
    transactionData,
    loading,
    setLoading,
    clientId,
    selectedCompanyName,
    selectedEscrowName,
  } = useAllProduct();

  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [transactionSet, setTransactionSet] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [refreshData, setRefreshData] = useState(false);

  const [selectedFilter, setSelectedFilter] = useState({
    range: "recent",
    startDate: null,
    endDate: null,
    txnType: "all",
  });

  const [filters, setFilters] = useState({
    startDate: null,
    endDate: null,
    txnType: "all",
    selectedRange: "recent",
  });

  const getDateRange = (rangeType) => {
    const today = dayjs();
    switch (rangeType) {
      case "today":
        return { startDate: today.startOf("day"), endDate: today.endOf("day") };
      case "yesterday":
        return {
          startDate: today.subtract(1, "day").startOf("day"),
          endDate: today.subtract(1, "day").endOf("day"),
        };
      case "last7days":
        return {
          startDate: today.subtract(7, "day").startOf("day"),
          endDate: today.endOf("day"),
        };
      case "last30days":
        return {
          startDate: today.subtract(30, "day").startOf("day"),
          endDate: today.endOf("day"),
        };
      default:
        return { startDate: null, endDate: null };
    }
  };

  useEffect(() => {
    if (selectedFilter.range && selectedFilter.range !== "custom") {
      const { startDate, endDate } = getDateRange(selectedFilter.range);
      setSelectedFilter((prev) => ({
        ...prev,
        startDate,
        endDate,
      }));
    }
  }, [selectedFilter.range]);

  useEffect(() => {
    console.log("refress-->");

    const fetchData = async () => {
      try {
        setLoading(true);
        const queryParams = new URLSearchParams({
          clientId,
          selectedCompanyName,
          selectedEscrowName,
        });
        const res = await axios.get(
          `${
            config.node_api_endpoint
          }/api/transaction-payout-details?${queryParams.toString()}`,
          {
            headers: {
              "Content-Type": "application/json",
              "x-api-key": process.env.REACT_APP_API_KEY, // ✅ your API key here
            },
          }
        );
        console.log("res--->", res);
        if (res.status === 200) {
          setRefreshData(false)
          setTransactionSet(res.data.data);
        }
      } catch (err) {
        console.error("Server error while fetching payout details:", err);
      } finally {
        setLoading(false); // ✅ Stop loader
      }
    };

    fetchData();
  }, [selectedCompanyName, selectedEscrowName, refreshData]);

  const columns = [
    {
      id: "expandIcon",
      label: "",
      minWidth: 50,
      style: {
        fontSize: "14px",
        fontWeight: 500,
        fontFamily: '"Roboto", sans-serif',
      },
    },
    {
      id: "created_at",
      label: "Date",
      minWidth: 100,
      // format: (value) => dayjs(value, "DD/MM/YYYY hh:mm:ss A").format("DD MMM YYYY, hh:mm A"),
      style: {
        fontSize: "16px",
        fontWeight: 400,
        fontFamily: '"Roboto", sans-serif',
      },
    },
    {
      id: "beneficiary_name",
      label: "Contact Name",
      minWidth: 150,
      style: {
        fontSize: "15px",
        fontWeight: 400,
        fontFamily: '"Roboto", sans-serif',
        textTransform: "capitalize",
      },
    },
    {
      id: "amount",
      label: "Debit",
      minWidth: 100,
      format: (value) => (value ? `₹ ${value}` : "---"),
      style: {
        // color: "#FF4D49",
        fontSize: "15px",
        fontWeight: 400,
        fontFamily: '"Roboto", sans-serif',
      },
    },
    {
      id: "credit_amount",
      label: "Credit",
      minWidth: 100,
      format: (value) => (value ? `₹ ${value}` : "---"),
      style: {
        // color: "#029646",
        fontSize: "15px",
        fontWeight: 400,
        fontFamily: '"Roboto", sans-serif',
      },
    },
    {
      id: "closing_balance",
      label: "A/c Balance",
      minWidth: 120,
      format: (value) => (value ? `₹ ${value}` : "---"),
      style: {
        fontSize: "15px",
        fontWeight: 400,
        fontFamily: '"Roboto", sans-serif',
      },
    },
    {
      id: "utr",
      label: "UTR/BANKRRN",
      minWidth: 150,
      format: (value) => value || "---",
      style: {
        fontSize: "14px",
        fontWeight: 400,
        fontFamily: '"Roboto", sans-serif',
        // fontStyle: "italic",
      },
    },
    {
      id: "bank_account",
      label: "A/c No /UPI",
      minWidth: 150,
      format: (value) => value || "---",
      style: {
        fontSize: "14px",
        fontWeight: 400,
        fontFamily: '"Roboto", sans-serif',
      },
    },
  ];

  const onRowClick = (index) => {
    const newExpandedRowKeys = expandedRowKeys.includes(index)
      ? expandedRowKeys.filter((key) => key !== index)
      : [...expandedRowKeys, index];
    setExpandedRowKeys(newExpandedRowKeys);
  };

  const RedPlaceholder = ({ value }) => {
    return value ? (
      <Typography>{value}</Typography>
    ) : (
      <Typography sx={{ color: "#4C4E64" }}>------</Typography>
    );
  };

  const expandedRowRender = (record) => (
    <Box
      sx={{
        display: "flex",
        padding: 2,
        backgroundColor: "#FFFFFF",
        alignItems: "stretch",
        borderBottomLeftRadius: "12px",
        borderBottomRightRadius: "12px",
        // marginBottom: "3px",
        // border:"2px solid red",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Box sx={{ flex: 1, pr: 2 }}>
        <Box sx={{ display: "flex", mb: 3 }}>
          <Typography sx={{ width: 150, fontWeight: 500 }}>Date</Typography>
          <Typography>
            : <span style={{ padding: "0 12px" }}>{record.created_at}</span>
          </Typography>
        </Box>
        <Box sx={{ display: "flex", mb: 3 }}>
          <Typography sx={{ width: 150, fontWeight: 500 }}>
            Contact Name
          </Typography>
          <Typography>
            :{" "}
            <span style={{ padding: "0 12px" }}>{record.beneficiary_name}</span>
          </Typography>
        </Box>
        <Box sx={{ display: "flex", mb: 3 }}>
          <Typography sx={{ width: 150, fontWeight: 500 }}>Debit</Typography>
          <Typography>
            :{" "}
            <span style={{ padding: "0 12px" }}>
              {record.amount || "------"}
            </span>
          </Typography>
        </Box>
        <Box sx={{ display: "flex", mb: 3 }}>
          <Typography sx={{ width: 150, fontWeight: 500 }}>Credit</Typography>
          <Typography>
            :{" "}
            <span style={{ padding: "0 12px" }}>
              {record.credit_amount || "------"}
            </span>
          </Typography>
        </Box>
        <Box sx={{ display: "flex", mb: 3 }}>
          <Typography sx={{ width: 150, fontWeight: 500 }}>
            A/c Balance
          </Typography>
          <Typography>
            :{" "}
            <span style={{ padding: "0 12px" }}>
              {record.closing_balance || "------"}
            </span>
          </Typography>
        </Box>
        <Box sx={{ display: "flex", mb: 3 }}>
          <Typography sx={{ width: 150, fontWeight: 500 }}>
            Transaction Note
          </Typography>
          <Typography>
            :{" "}
            <span style={{ padding: "0 12px" }}>
              {record.transaction_note || "------"}
            </span>
          </Typography>
        </Box>
        <Box sx={{ display: "flex", mb: 3 }}>
          <Typography sx={{ width: 150, fontWeight: 500 }}>
            UTR / RRN
          </Typography>
          <Typography>
            :{" "}
            <span style={{ padding: "0 12px" }}>{record.utr || "------"}</span>
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          width: "2px",
          backgroundImage:
            "linear-gradient(#d9d9d9 33%, rgba(255,255,255,0) 0%)",
          backgroundPosition: "right",
          backgroundSize: "2px 8px",
          backgroundRepeat: "repeat-y",
          marginX: 2,
        }}
      />
      <Box sx={{ flex: 1, pl: 2 }}>
        <Box sx={{ display: "flex", mb: 3 }}>
          <Typography sx={{ width: 150, fontWeight: 500 }}>A/c No</Typography>
          <Typography>
            :{" "}
            <span style={{ padding: "0 12px" }}>
              {!record.bank_account.includes("@")
                ? record.bank_account
                : "------"}
            </span>
          </Typography>
        </Box>
        <Box sx={{ display: "flex", mb: 3 }}>
          <Typography sx={{ width: 150, fontWeight: 500 }}>
            UTR/BANKRRN
          </Typography>
          <Typography>
            :{" "}
            <span style={{ padding: "0 12px" }}>{record.utr || "------"}</span>
          </Typography>
        </Box>
        <Box sx={{ display: "flex", mb: 3 }}>
          <Typography sx={{ width: 150, fontWeight: 500 }}>IFSC</Typography>
          <Typography>
            :{" "}
            <span style={{ padding: "0 12px" }}>{record.ifsc || "------"}</span>
          </Typography>
        </Box>
        <Box sx={{ display: "flex", mb: 3 }}>
          <Typography sx={{ width: 150, fontWeight: 500 }}>UPI</Typography>
          <Typography>
            :{" "}
            <span style={{ padding: "0 12px" }}>
              {record.bank_account.includes("@")
                ? record.bank_account
                : "------"}
            </span>
          </Typography>
        </Box>
        <Box sx={{ display: "flex", mb: 3 }}>
          <Typography sx={{ width: 150, fontWeight: 500 }}>
            Sender A/c Name
          </Typography>
          <Typography>
            :{" "}
            <span style={{ padding: "0 12px" }}>
              {record.sender_account_name || "------"}
            </span>
          </Typography>
        </Box>
        <Box sx={{ display: "flex", mb: 3 }}>
          <Typography sx={{ width: 150, fontWeight: 500 }}>Mode</Typography>
          <Typography>
            :{" "}
            <span style={{ padding: "0 12px" }}>{record.mode || "------"}</span>
          </Typography>
        </Box>
      </Box>
    </Box>
  );

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPageSize(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  const applyFilters = (newFilters) => {
    setFilters((prev) => ({
      ...prev,
      ...newFilters,
    }));
    setCurrentPage(0);
  };

  const filteredData = transactionSet?.filter((row) => {
    const searchTerm = search.toLowerCase();
    const txnDate = dayjs(row.created_at); // ← Parse as ISO

    const matchesSearch =
      row.beneficiary_name?.toLowerCase().includes(searchTerm) ||
      row.utr?.toLowerCase().includes(searchTerm) ||
      row.bank_account?.toLowerCase().includes(searchTerm) ||
      row.created_at?.toLowerCase().includes(searchTerm);

    const matchesTxnType =
      filters.txnType === "all" ||
      (filters.txnType === "debit" && row.amount) ||
      (filters.txnType === "credit" && row.credit_amount);

    const matchesDate =
      (!filters.startDate ||
        txnDate.isAfter(dayjs(filters.startDate).subtract(1, "second"))) &&
      (!filters.endDate ||
        txnDate.isBefore(dayjs(filters.endDate).add(1, "second")));

    return matchesSearch && matchesTxnType && matchesDate;
  });

  const paginatedData = filteredData
    ?.slice()
    ?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    ?.slice(currentPage * pageSize, currentPage * pageSize + pageSize);
  console.log("refreshData-->", refreshData);

  return (
    <>
      <FullScreenLoader spinning={loading} />
      <div className={`${styles.hellogetintofintechParent} mt-5`}>
        <div className={styles.availableBalance}>
          Hello, {selectedCompanyName ? selectedCompanyName : ""}
        </div>
        <div className={`${styles.welcomeToThe}`}>
          Welcome to the world of digital escrow
        </div>
      </div>

      <div
        className={`${styles.frameParent} d-flex mt-4 justify-content-start w-100 gap-4`}
      >
        <div className={`${styles.saveMoney1044644423Parent} d-flex w-25`}>
          <div className={`${styles.saveMoney1044644423} m-2`}>
            <img className={styles.vectorIcon} alt="" src="/vector.svg" />
          </div>
          <div className={styles.availableBalanceParent}>
            <div className={styles.availableBalance}>Available Balance*</div>
            <div className={styles.div}>
              ₹ {transactionData?.data?.balance ? "" : "9,80,88,546"}
            </div>
          </div>
        </div>
        <div className={`${styles.saveMoney1044644423Parent} d-flex w-25`}>
          <div className={`${styles.saveMoney1044644423} m-2`}>
            <img
              className={styles.accountConfigurationIcon}
              alt=""
              src="/account-configuration.svg"
            />
          </div>
          <div className={`${styles.availableBalanceParent} d-flex`}>
            <div className={styles.availableBalance}>Account Details*</div>
            <div className="mt-1">
              Ac.no :
              <span>
                {transactionData?.data?.van?.acc_no
                  ? transactionData?.data?.van?.acc_no
                  : "PHEDPHEDNTRAN"}
              </span>
            </div>
            <div>
              IFSC &nbsp; :
              <span>
                {transactionData?.data?.van.ifsc
                  ? transactionData?.data?.van.ifsc
                  : "UTIB0CCH274"}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div style={{ maxHeight: "80vh" }}>
        <TransactionFilter
          page="transaction"
          setSearch={setSearch}
          dataSource={transactionData}
          applyFilters={applyFilters}
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
          setRefreshData={setRefreshData}
        />

        <Box>
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 200,
              }}
            >
              <CircularProgress />
              <Typography sx={{ ml: 2 }}>Loading...</Typography>
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  backgroundColor: "#fff",
                  border: "1px solid #D9D9D9",
                  borderTopLeftRadius: 0,
                  borderTopRightRadius: 0,
                  borderBottomLeftRadius: "8px",
                  borderBottomRightRadius: "8px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                  // padding: 2,
                  overflowX: "auto",
                }}
              >
                <div className={styles.reportTable}>
                  <div className={styles.tableHeader}>
                    <div className={styles.cell}></div>
                    <div className={styles.cell}>Date</div>
                    <div className={styles.cell}>Contact Name</div>
                    <div className={styles.cell}>Debit</div>
                    <div className={styles.cell}>Credit</div>
                    <div className={styles.cell}>A/c Balance</div>
                    <div className={styles.cell}>UTR/BANKRRN</div>
                    <div className={styles.cell}>A/c No /UPI</div>
                  </div>

                  {paginatedData?.length === 0 ? (
                    <div
                      className="py-4 text-center"
                      style={{ fontWeight: 500, color: "#666" }}
                    >
                      No transactions available
                    </div>
                  ) : (
                    paginatedData?.map((row, index) => {
                      const globalIndex = currentPage * pageSize + index;
                      const isExpanded = expandedRowKeys.includes(globalIndex);

                      return (
                        <React.Fragment key={globalIndex}>
                          <div
                            className={`${styles.tableRow}`}
                            onClick={() => onRowClick(globalIndex)}
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            <div className={styles.cell}>
                              <IconButton size="small">
                                {isExpanded ? (
                                  <ArrowDropDown />
                                ) : (
                                  <ArrowRight />
                                )}
                              </IconButton>
                            </div>
                            <div className={styles.cell}>{row.created_at}</div>
                            <div className={styles.cell}>
                              {row.beneficiary_name}
                            </div>
                            <div
                              className={styles.cell}
                              style={{
                                color: row.amount ? "#FF4D49" : "inherit",
                              }}
                            >
                              {row.amount ? `₹ ${row.amount}` : "---"}
                            </div>
                            <div
                              className={styles.cell}
                              style={{
                                color: row.credit_amount
                                  ? "#029646"
                                  : "inherit",
                              }}
                            >
                              {row.credit_amount
                                ? `₹ ${row.credit_amount}`
                                : "---"}
                            </div>
                            <div className={styles.cell}>
                              {row.closing_balance
                                ? `₹ ${row.closing_balance}`
                                : "---"}
                            </div>
                            <div className={styles.cell}>
                              {row.utr || "---"}
                            </div>
                            <div className={styles.cell}>
                              {row.bank_account || "---"}
                            </div>
                          </div>

                          {/* Expanded */}
                          <Collapse
                            in={isExpanded}
                            timeout="auto"
                            unmountOnExit
                          >
                            <div
                              // className="p-3"
                              style={{
                                background: "#FAFAFA",
                                borderBottom: "1px solid #eee",
                              }}
                            >
                              {expandedRowRender(row)}
                            </div>
                          </Collapse>
                        </React.Fragment>
                      );
                    })
                  )}
                </div>

                <TablePagination
                  rowsPerPageOptions={[10, 20, 50, 100]}
                  component="div"
                  count={filteredData?.length}
                  rowsPerPage={pageSize}
                  page={currentPage}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  sx={{
                    "& .MuiTablePagination-selectLabel": {
                      marginTop: "14px",
                    },
                    "& .MuiTablePagination-displayedRows": {
                      marginTop: "14px",
                    },
                  }}
                />
              </Box>
            </>
          )}
        </Box>
      </div>
    </>
  );
};

export default Transaction;
